import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { getpaymentIdMaster } from '../../../CommonURL';
import { useSelector } from 'react-redux';
import { getMasterDataToken } from '../../../Utils/restUtils';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Transparentspinner from '../../Common/loader/Transparentspinner';
import { Col, Media, Row } from 'reactstrap';
import { Email, Mob, Mobile, TaxIn } from '../../../Constant';
import logo from '../../../assets/images/logo/dark-logog.svg';

const RenewSub = () => {
    const [spinnerTrans, setspinnerTrans] = useState(true);
    const authState = useSelector((state) => state.auth);
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const paymentId = params.get("payment_id");

    const [apidata, setapidata] = useState({});
    const [invoice, setinvoice] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        handlePayment();
    }, []);

    const componentRef = useRef(null);
    const componentRefFullPage = useRef(null);

    const handlePrintThermal = useReactToPrint({
        content: () => componentRef.current,
    });

    const handlePrintFullPage = useReactToPrint({
        content: () => componentRefFullPage.current,
    });

    const handlePayment = async () => {
        let get_api = await getMasterDataToken(
            getpaymentIdMaster + `?payment_id=${paymentId}`
        );

        if (get_api?.data?.status === true) {
            setapidata(get_api.data.payment);
            const invoices_map = get_api?.payment?.invoices_reflected?.join(', ');
            setinvoice(invoices_map);
        } else if (get_api?.status >= 400 && get_api.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (get_api?.status >= 500 && get_api.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setspinnerTrans(false);
    };

    const handleBackToinvoice = () => {
        location?.state?.backTwoStep ? navigate(-2) : navigate(-1);
    };

    return (
        <Fragment>
            {spinnerTrans && <Transparentspinner />}

            <style>
                {`
                 .detail-item {
        display: flex;
        justify-content: space-between;
      
    }

    .detail-item p,
    .detail-item span {
        margin: 0;
        padding: 0;
        white-space: nowrap;
    }
        
.print-button {
  background-color: navy;
  color: white;
  padding: 6px 20px;
  border: none;
  border-radius: 5px;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}

.print-button:hover {
  background-color: rgb(138, 138, 192);
}

.thank-you {
  margin-top: -20px;
}

.customer-details {
  margin-bottom: 4px;
}

.customer-add {
  font-weight: 500;
}

.customer-add p {
  margin: -2px;
}

.customer-name {
  margin: -4px;
  font-weight: 800;
  font-size: 15px;
}

.customer-address p {
  // margin: -10px 0;
  font-weight: 400;
  font-size: 12px;
}
  
.left {
  margin-right: 10px;
  font-weight: 600;
}

.right {
  margin-left: 10px;
  text-align: right;
}

                    @media print {
                        @page {
                            size: A4;
                            margin: 0;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }

                        .thermal-print {
                            width: 200px;
                            margin: 0;
                            position: absolute;
                            top: 0;
                            left: 0;
                            padding: 10px;
                            text-align: left;
                        }
                        .thermal-print hr {
                            margin-top: -4px !important;
                        }

                        .full-page-print {
                            width: 100%;
                            padding: 20px;
                            text-align: left;
                        }
                        .full-page-print hr {
                            margin-top: 10px !important;
                        }

                        .detail-item {
                            display: flex;
                            justify-content: space-between;
                        }
                    }
                `}
            </style>

           
            <div className="print-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' ,marginBottom:'15px'}}>
                <div className="" style={{ backgroundColor: 'white', padding: '12px', borderRadius: '8px' }}>

                   <div className="receipts thermal-print " style={{ textAlign: 'left' }} ref={componentRef}>
                        <hr className="hr-line" />
                        <div style={{ textAlign: 'center' }}>  
                                    <>
                                       
                                          <img style={{ width: '150px', marginBottom: '2px' }} src={logo} alt='logo' />
                                        <h3>+91 7012733393</h3>
                                    </>
                            
                            {/* <img style={{ width: '150px' }} src={logo} alt='logo' /> */}
                           <hr className="hr-line" style={{ marginTop: '5px' }} />
                            <h4>PAYMENT RECEIPT</h4>
                            <hr className="hr-line" style={{ marginTop: '5px' }} />
                        </div>

                        <h6>Company Details:</h6>
                         <div className="customer-add">
                              <p className="customer-name">{apidata.company_name}</p>
                               <div className="customer-address"
                                style={{
                                    wordWrap: 'break-word',
                                    overflowWrap: 'break-word',
                                    whiteSpace: 'normal',
                                }}
                            >
                           <p>{apidata.email}</p>
                           <p>+{apidata.country_code}{apidata.company_phone}</p>
                            </div>
                           </div>

                     
                         <hr className="hr-line" style={{ marginTop: '10px' }} />
                        <div className="details-container">
                            <div className="detail-item">
                                <p className="left">Customer id#</p>
                           <span className="right text-decoration-underline">{apidata.user_id}</span>
                            </div>

                       <div className="detail-item">
                                <p className="left">Receipt No#</p><span className="right">{apidata.receipt_no}</span>
                        </div>

                        <div className="detail-item">
                                <p className="left">Txn id#</p><span className="right">{apidata.payment}</span>
                        </div>

                       <div className="detail-item">
                                <p className="left">Transaction Date</p><span className="right">{apidata.paid_at}</span>
                        </div>

                       <div className="detail-item">
                                <p className="left">Payment Method</p><span className="right">{apidata.payment_method_name}</span>
                        </div>

                        {/* <div className="detail-item">
                                <p className="left">Sales agent</p><span className="right">{apidata.sales_agent}</span>
                        </div> */}
                      </div>
                        <hr className="hr-line" style={{ marginTop: '-1px' }} />
                        <div className="detail-item">
                            <p className="left">Paid Amount</p>
                      <span className="right">{authState?.currency || ""} ₹ {apidata?.paid_amount || ""}</span>
                     </div>
                         <hr className="hr-line" style={{ marginTop: '-5px' }} />
                        <div className="invoice-details">
                            <div className="detail-item">
                                <p className="left">Invoices Number</p><span className="right"><Link  to={`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${apidata.User_id}&order_id=${apidata.order_id}`} > {apidata?.invoice_number}</Link></span>
                        </div>

                        {apidata.description && (
                           <div className="detail-item">
                             <p className="left">Description</p><span>{apidata.description}</span>
                            </div>
                        )}

                        {apidata.reference !== null && (
                                <div className="detail-item">
                                    <p className="left">Ref:</p><span className="right">{apidata.reference}</span>
                                </div>
                            )}
                       {/* <div className="detail-item">
                        <p className="left">Total Dues</p>
                        <span className="right">{authState?.currency || ""} {apidata?.pending_due || ""}</span>
                       </div> */}


                       {/* <div className="detail-item">
                        <p className="left">Wallet Money</p>
                       <span className="right">{authState?.currency || ""} {apidata?.wallet_money || ""}</span>
                      </div> */}
                </div>
                        <p className='text-center mt-5'>Thank you</p>
                        <p style={{ textAlign: 'center' }}>**********</p>
                    </div>

                    {/* ---------------- FULL PAGE PRINT ---------------- */}
                    <div style={{ display: 'none' }}>
                        <div className="receipts full-page-print" ref={componentRefFullPage}>
                            <Row className="d-flex justify-content-between">
                                {/* <Col sm="2">
                                    <Media>
                                        <Image attrImage={{ className: 'img-60', src: imageUrl }} />
                                    </Media>
                                </Col> */}

                                <Col sm="5">
                                    {/* <img style={{ width: '150px' }} src={logo} alt='logo' /> */}
                                </Col>

                                <Col sm="5" className="text-end">
                                    <strong>{apidata.user_name}</strong><br />
                                    {apidata.customer_address}<br />
                                    {Mobile}: +{apidata.customer_number}<br />
                                    {Email}: {apidata.customer_email}<br />
                                    {TaxIn}: {apidata.transaction_id}<br />
                                </Col>
                            </Row>

                            <hr className="hr-line" style={{ marginTop: '5px' }} />
                                <h4>PAYMENT RECEIPT</h4>
                                <hr className="hr-line" style={{ marginTop: '5px' }} />

                             <div className="details-container">
                                <div className="detail-item">
                                    <p className="left">Customer id#</p><span>{apidata.subscriber_id}</span>
                            </div>

                             <div className="detail-item">
                                    <p className="left">Receipt No# </p><span className="right">{apidata.receipt_no}</span>
                              </div>

                            <div className="detail-item">
                               <p className="left">Txn id#</p><span className="right">{apidata.payment}</span>
                            </div>

                            <div className="detail-item">
                                <p className="left">Transaction Date</p><span className="right">{apidata.transaction_date}</span>
                            </div>

                            <div className="detail-item">
                                <p className="left">Payment Method</p><span className="right">{apidata.payment_method_name}</span>
                            </div>

                            {/* <div className="detail-item">
                                <p className="left">Sales agent</p><span className="right">{apidata.sales_agent}</span>
                            </div> */}
                            </div>
                            <hr />

                            <div className="detail-item">
                                <p className="left">Paid Amount</p><span className="right">{authState?.currency || ""} {apidata.paid_amount}</span>
                            </div>

                            <hr />

                            <div className="detail-item">
                                <p className="left">Invoices reflected</p><span className="right">{invoice}</span>
                            </div>

                            {apidata.description && (
                                <div className="detail-item">
                                    <p className="left">Description</p><span className="right">{apidata.description}</span>
                                </div>
                            )}

                            {apidata.reference && (
                                <div className="detail-item">
                                    <p className="left">Ref</p><span className="right">{apidata.reference}</span>
                                </div>
                            )}

                            {/* <div className="detail-item">
                                <p className="left">Total Dues</p><span className="right">{authState?.currency || ""}{apidata.pending_due}</span>
                            </div> */}

                            {/* <div className="detail-item">
                                <p className="left">Wallet Money</p><span className="right">{authState?.currency || ""} {apidata.wallet_money}</span>
                            </div> */}
                            <p className='text-center mt-5'>Thank you</p>

                            <p style={{ textAlign: 'center' }}>*******</p>
                        </div>
                    </div>

                    {/* ---------------- BUTTONS ---------------- */}
                   <hr className="hr-line" style={{ marginTop: '-5px' }} />
                    <div className="button-print text-center">
                        <button className="print-button" onClick={() => handleBackToinvoice()} >Back</button>
                        <button className="print-button" onClick={handlePrintThermal}>Thermal Print</button>
                        <button className="print-button" onClick={handlePrintFullPage}>Print</button>

                    </div>

                </div>
            </div>
        </Fragment>
    );
};

export default RenewSub;
